import { css } from '../lib';

export const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195,
  long: 600,
  longest: 1000,
  skeleton: 1500,
};

export const easing = {
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
};

type TransitionProperties =
  | 'all'
  | 'background'
  | 'background-color'
  | 'background-position'
  | 'background-size'
  | 'border'
  | 'box-shadow'
  | 'font-size'
  | 'height'
  | 'margin'
  | 'margin-bottom'
  | 'margin-left'
  | 'margin-right'
  | 'margin-top'
  | 'max-height'
  | 'max-width'
  | 'opacity'
  | 'scale'
  | 'stroke-dasharray'
  | 'stroke-dashoffset'
  | 'transform'
  | 'transform-origin'
  | 'translate'
  | 'translate3D'
  | 'vertical-align'
  | 'visibility'
  | 'width'
  | 'z-index'
  | 'zoom';

type Easing = keyof typeof easing;
type Duration = keyof typeof duration;

export const transition = (kind: TransitionProperties = 'all') => ({
  easing: (easingType: Easing = 'easeInOut') => ({
    duration: (durationValue: Duration | number = 'standard') => {
      const transitionTime =
        typeof durationValue === 'number' ? durationValue : duration[durationValue];

      return css`
        transition: ${kind} ${easing[easingType]} ${transitionTime}ms;
      `;
    },
  }),
});
